export default __webpack_public_path__ + "static/media/fastTrackAppointments_2222x1219.f6358d0c.jpg";